import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    globalLoader: true,
}

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        loading: (state) => {
            state.globalLoader = true
        },
        loaded: (state) => {
            state.globalLoader = false
        }
    },
    extraReducers: {
        ['fetchHome/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchAbout/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchContact/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchEquipment/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchProject/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
        ['fetchProjectDetail/fulfilled']: (state, action) => {
            state.globalLoader = false
        },
    }
})


export default globalSlice.reducer
export const {loaded, loading} = globalSlice.actions
